<template>
  <section
    id="workflow-users-list relative"
    class="!bg-container-background rounded-xl !h-mainCardHeight overflow-y-auto"
  >
    <div
      class="inner-navbar py-2 !border-b border-page-border sticky top-0 bg-container-background z-[1] !mb-3"
    >
      <el-row type="flex" align="middle" class="" :class="getIsMobile ? 'mt-2' : ''">
        <el-col :span="12">
          <div class="icon-block d-flex align-center !gap-1.5 !px-3">
            <div
              class="icon"
              v-if="
                (!this.$route.query.routeType || this.$route.query.routeType == 'FB') &&
                !this.isApplicationUserSide &&
                displayBackButton
              "
            >
              <el-button
                @click="backToWorkFlows"
                size="mini"
                class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
              >
                <span>
                  <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
                </span>
              </el-button>
            </div>
            <h3
              class="!text-sm pl-1 2xl:!text-base !font-normal !text-black-950 !m-0 !w-64 truncate"
            >
              {{ getFlowName() }}
            </h3>
          </div>
        </el-col>
        <el-col>
          <div class="flex items-center justify-end w-full gap-2 pr-2.5">
            <el-tooltip content="Create Iframe link" placement="top">
              <el-link
                class="!py-1 !px-1.5 !rounded-sm !border border-solid border-black-300 !bg-white hover:bg-black-100"
                :underline="false"
                v-if="getIframeUrlInfo == null && !isApplicationUserSide"
                @click="openViewConfigPage"
              >
                <img src="@/assets/img/icons/new/link-icon.svg" alt="" class="!size-4" />
              </el-link>
            </el-tooltip>
            <el-button
              v-if="
                IframePermissions('ADD', 'FormBuilderUserDate') &&
                !currentMenu?.formbuilder_approval_filter.length &&
                !isUserFieldPresent
              "
              class="right-block float-right add-buttons mt-0 mr-0"
              type="primary"
              @click="openStartFormbuilder"
              :size="buttonSize"
              :style="buttonStyles"
            >
              <span class="flex items-center">
                <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3 !mr-1" />
                <span class="text-xs font-light text-white">
                  {{
                    getFormBuilder &&
                    getFormBuilder.customization &&
                    getFormBuilder.customization.add_button_label
                      ? getFormBuilder.customization.add_button_label
                      : 'Add'
                  }}
                </span>
              </span>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div id="gradientBg" class="mx-2">
      <div
        class="grid grid-cols-[1fr_auto] items-end justify-between !text-white !rounded-md !gap-3 !pr-4"
      >
        <div v-if="workFlowPublicURL">
          <div
            v-if="
              IframePermissions('GET LINK', 'FormBuilderList') &&
              IframePermissions('GET LINK', 'FormBuilderUserDate')
            "
          >
            <el-alert :closable="false" class="!bg-transparent !font-normal">
              <template slot="title">
                <span class="!text-black-950 font-normal">
                  You can share form builder with public URL
                </span>
              </template>

              <template class="!bg-card-color !p-[10px]">
                <span class="!text-black-950">{{ workFlowPublicURL }}</span>

                <el-button
                  icon="el-icon-copy-document"
                  @click="copyURL(workFlowPublicURL)"
                  size="mini"
                  class="ml-1 !p-1.5"
                ></el-button>
              </template>
            </el-alert>
          </div>
        </div>

        <div
          class="!pb-4"
          style="height: --webkit-fill-available"
          v-if="
            getFormBuilder &&
            getFormBuilder.customization &&
            getFormBuilder.customization.show_detailed_link &&
            IframePermissions('DETAILED VIEW', 'FormBuilderUserDate')
          "
        >
          <router-link
            :to="getFormbuilderTableDataRoute"
            class="!border !border-brand-500 !text-brand-500 !py-1.5 !px-3 !rounded-sm"
          >
            <i class="fa fa-eye"></i>
            <span class="text-sm">Detailed View</span>
          </router-link>
        </div>
      </div>
    </div>
    <el-row
      :gutter="12"
      v-if="
        getFormBuilder && getFormBuilder.settings && getFormBuilder.settings.limit_total_submissions
      "
    >
      <el-col :span="8">
        <el-card shadow="always">
          Total Allowed -
          {{ getFormBuilder.settings.no_total_submissions_limited }}
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="always">Total Submited - {{ total }}</el-card>
      </el-col>
    </el-row>

    <el-row
      :gutter="12"
      v-if="
        getFormBuilder &&
        getFormBuilder.settings &&
        getFormBuilder.settings.limit_total_submissions &&
        getFormBuilder.settings.no_total_submissions_limited == total
      "
    >
      <el-col :span="24">
        <el-alert
          title="Form builder Completed"
          type="success"
          description="Form builder reach our maximum submissions"
          show-icon
          closable
        ></el-alert>
      </el-col>
    </el-row>

    <el-row :gutter="12" v-if="selectedUserId">
      <el-col :span="6">
        <el-select v-model="selectedUserId" @change="updateUserQuery">
          <el-option
            v-for="(user, index) of getFormbuilderUniqueUsersData.data"
            :key="index"
            :label="getUserEmail(user)"
            :value="getUserId(user)"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>

    <div class="mt-1">
      <div class="main-div d-flex justify-between !px-3">
        <div class="float-left">
          <el-dropdown class="mb-4" v-if="selectedRowsIds.length > 0">
            <button
              class="!bg-brand-500 text-xs 2xl:text-smd text-white !py-1.5 !px-4 !rounded-md !border-none"
              type="button"
            >
              Bulk Actions
            </button>
            <el-dropdown-menu slot="dropdown">
              <template>
                <a
                  @click="approveAllChecked"
                  v-if="isApprovalFormbuilder && checkIsLoginUserAsApproverUser()"
                >
                  <el-dropdown-item command="approve">
                    <i class="fa fa-check"></i>
                    Approve
                  </el-dropdown-item>
                </a>
                <a
                  @click="showBulkRejectConfirm"
                  v-if="isApprovalFormbuilder && checkIsLoginUserAsApproverUser()"
                >
                  <el-dropdown-item command="reject">
                    <i class="fa fa-times"></i>
                    Reject
                  </el-dropdown-item>
                </a>
                <a
                  @click="holdAllChecked"
                  v-if="isApprovalFormbuilder && checkIsLoginUserAsApproverUser()"
                >
                  <el-dropdown-item command="approve">
                    <i class="fa fa-hourglass-half"></i>
                    {{ approvalHoldName }}
                  </el-dropdown-item>
                </a>
                <a @click="deleteChecked">
                  <el-dropdown-item command="delete">
                    <i class="fa fa-trash-o"></i>
                    Delete
                  </el-dropdown-item>
                </a>
                <a @click="handleNotificationClick">
                  <el-dropdown-item command="notifications">
                    <i class="el-icon-message"></i>
                    Notifications
                  </el-dropdown-item>
                </a>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          class="mb-1 d-flex align-items-center justify-end filter-container"
          v-if="!getIsMobile"
        >
          <div class="filter-item">
            <el-select
              v-if="!currentMenu?.formbuilder_approval_filter?.length"
              v-model="approvalFilter"
              @change="fetchAllEmployee"
              placeholder="Filter by Approval Status"
              size="small"
              clearable
              multiple
              collapse-tags
            >
              <el-option
                :label="approvalHoldName ? approvalHoldName.toUpperCase() : 'HOLD'"
                value="HOLD"
              ></el-option>
              <el-option label="APPROVED" value="APPROVED"></el-option>
              <el-option label="REJECTED" value="REJECTED"></el-option>
              <el-option label="PENDING" value="PENDING"></el-option>
              <el-option label="DRAFT" value="DRAFT"></el-option>
            </el-select>
          </div>

          <div class="filter-item">
            <el-select
              v-model="sentStatusFilter"
              @change="onSentStatusChange"
              placeholder="Filter by Sent Status"
              size="small"
              clearable
            >
              <el-option label="Today" value="today"></el-option>
              <el-option label="Yesterday" value="yesterday"></el-option>
              <el-option label="This Week" value="this_week"></el-option>
              <el-option label="Last Week" value="last_week"></el-option>
              <el-option label="This Month" value="this_month"></el-option>
              <el-option label="Last Month" value="last_month"></el-option>
              <el-option label="This Year" value="this_year"></el-option>
              <el-option label="Last Year" value="last_year"></el-option>
              <el-option label="Custom Date Range" value="custom_date_range"></el-option>
            </el-select>
          </div>

          <div class="filter-item" v-if="sentStatusFilter == 'custom_date_range'">
            <el-date-picker
              v-model="customDateRange"
              type="daterange"
              format="yyyy-MM-dd"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="onDateRangeChange"
            />
          </div>

          <div class="filter-item">
            <el-input
              v-model="searchQuery"
              prefix-icon="el-icon-search"
              placeholder="Search"
              clearable
              @input="fetchAllEmployee"
              size="small"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="vue-data-table-default">
        <data-tables-server
          :data="data"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading || resendLoading"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="resendLoading ? 'Sending the form, please wait...' : loadingText"
          v-if="!getIsMobile"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="User" min-width="210" sortable="custom">
            <template slot-scope="scope">
              <div class="d-flex" v-if="!isAnonymousForm()">
                <el-tooltip
                  v-if="getUserEmail(scope.row)"
                  :content="getUserEmail(scope.row)"
                  placement="top"
                  effect="light"
                >
                  <div style="margin-left: -5px">
                    <i class="fa fa-user-circle !text-brand-500" width="30"></i>
                    {{ getUserEmail(scope.row) | truncate(22, '...') }}
                  </div>
                </el-tooltip>
                <div v-else>{{ scope.row.ip_address }}</div>
              </div>
              <div v-else>
                <el-tooltip
                  v-if="getUserEmail(scope.row)"
                  :content="getUserEmail(scope.row)"
                  placement="top"
                  effect="light"
                >
                  <div>
                    <i class="fa fa-user-circle !text-brand-500" width="30"></i>
                    {{ getUserEmail(scope.row) | truncate(22, '...') }}
                  </div>
                </el-tooltip>
                <div v-else>{{ scope.row.ip_address }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Form ID"
            min-width="140"
            sortable="custom"
            v-if="isGenerateUniqueId"
          >
            <template slot-scope="scope">
              <div class="d-flex">
                {{ scope.row.formbuilderdata_unique_id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Enforce Order Status" min-width="200" v-if="!isAnonymousForm()">
            <template slot-scope="scope">
              <div
                v-if="scope.row.formbuilder_data_status == 'EXPIRED' && scope.row.next_user_data"
                class="log-expired"
              >
                <i class="el-icon-timer"></i>
                Expired at
                {{ getUserName(scope.row) }}
              </div>
              <div v-else-if="automationLogs[scope.row.automation_batch_data_id]">
                <div
                  class="success d-flex"
                  v-if="automationLogs[scope.row.automation_batch_data_id].status == 'COMPLETED'"
                >
                  <div>
                    <i class="el-icon-circle-check"></i>
                    <span class="d-inline-block !pl-1.5">Completed</span>
                  </div>
                  &nbsp;
                  <automationFormbuilderLogs
                    class="success"
                    :currentFormbuilderData="scope.row"
                    :allEntitiesData="allEntitiesData"
                    :allCompanyUserTypesData="allCompanyUserTypesData"
                    :usersLogs="automationLogs[scope.row.automation_batch_data_id].logs"
                  ></automationFormbuilderLogs>
                </div>
                <div
                  class="warning d-flex"
                  v-else-if="automationLogs[scope.row.automation_batch_data_id].currentUser"
                >
                  <div>
                    <i class="el-icon-time"></i>
                    <span class="d-inline-block !pl-1.5">
                      Waiting for
                      {{
                        automationLogs[scope.row.automation_batch_data_id].currentUser.user_name ||
                        automationLogs[scope.row.automation_batch_data_id].currentUser.user_email ||
                        'others'
                      }}
                    </span>
                  </div>
                  &nbsp;
                  <automationFormbuilderLogs
                    class="warning"
                    :currentFormbuilderData="scope.row"
                    :allEntitiesData="allEntitiesData"
                    :allCompanyUserTypesData="allCompanyUserTypesData"
                    :usersLogs="automationLogs[scope.row.automation_batch_data_id].logs"
                  ></automationFormbuilderLogs>
                </div>
                <div v-else class="warning d-flex">
                  &nbsp; Pending
                  <automationFormbuilderLogs
                    class="warning"
                    :currentFormbuilderData="scope.row"
                    :allEntitiesData="allEntitiesData"
                    :allCompanyUserTypesData="allCompanyUserTypesData"
                    :usersLogs="automationLogs[scope.row.automation_batch_data_id].logs"
                  ></automationFormbuilderLogs>
                </div>
              </div>
              <div class="dull-text">
                {{
                  scope.row.enforce_order
                    ? 'Involved in the enforce order'
                    : 'Not involved in the enforce order'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="action" min-width="120">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a
                    @click="onHold(scope.row)"
                    v-if="
                      checkIsApproverUser(scope.row) &&
                      scope.row.approval_status == 'PENDING' &&
                      getIframeUrlInfo == null
                    "
                  >
                    <el-dropdown-item icon="el-icon-video-pause" command="view">
                      {{ approvalHoldName ? approvalHoldName : 'HOLD' }}
                    </el-dropdown-item>
                  </a>
                  <a
                    @click="onApprove(scope.row)"
                    v-if="checkIsApproverUser(scope.row) && getIframeUrlInfo == null"
                  >
                    <el-dropdown-item icon="el-icon-finished" command="view">
                      Approve
                    </el-dropdown-item>
                  </a>
                  <a
                    @click="showRejectConfirm(scope.row)"
                    v-if="checkIsApproverUser(scope.row) && getIframeUrlInfo == null"
                  >
                    <el-dropdown-item icon="el-icon-circle-close" command="view">
                      Reject
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      IframePermissions('VIEW', 'FormBuilderUserDate') &&
                      checkReceiverPermissions('view', scope.row)
                    "
                    @click="viewFormbuilderData(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      IframePermissions('EDIT', 'FormBuilderUserDate') &&
                      checkReceiverPermissions('edit', scope.row)
                    "
                    @click="editWorkUserData(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                      Edit
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      IframePermissions('DELETE', 'FormBuilderUserDate') &&
                      checkReceiverPermissions('delete', scope.row)
                    "
                    @click="onDelete(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-delete" command="delete">
                      Delete
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      formbuilderDetails.allow_rework_on_form &&
                      scope.row.approval_status != 'APPROVED' &&
                      scope.row.approval_status != 'REJECTED' &&
                      checkContactEmail(scope.row) &&
                      checkIsApproverUser(scope.row)
                    "
                    @click="showReworkConfirm(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-refresh" command="rework">
                      {{ getReworkLabel() }}
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="formbuilderDetails.allow_export_as_excel"
                    @click="exportFormbuilderAsExcel(scope.row)"
                  >
                    <el-dropdown-item command="excel">
                      <i class="el-icon-upload2"></i>
                      Export as Excel
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="formbuilderDetails.allow_export_as_pdf"
                    @click="exportFormbuilderDataAsPdf(scope.row)"
                  >
                    <el-dropdown-item command="pdf">
                      <i class="fa fa-file-pdf-o"></i>
                      Export as Pdf
                    </el-dropdown-item>
                  </a>
                  <a @click="downloadDocuments(scope.row)">
                    <el-dropdown-item command="download-documents">
                      <i class="el-icon-download"></i>
                      Download Documents
                    </el-dropdown-item>
                  </a>
                  <a
                    @click="sendForApproval(scope.row)"
                    v-if="scope.row.approval_status == 'DRAFT'"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-s-promotion" command="send-for-approval">
                      Send for Approval
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <el-table-column v-if="hasIntervals" label="Submitted For" min-width="150">
            <template slot-scope="scope">
              <div>
                <span class="black-coral sm-80" v-if="scope.row.time_interval">
                  {{ scope.row.time_interval | moment(fequencyDateMap[intervalType]) }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="isApprovalFormbuilder"
            label="Approval Status"
            min-width="300"
            sortable="custom"
          >
            <template slot-scope="scope">
              <template v-if="!isAdvancedApproval">
                <div class="success" v-if="scope.row.approval_status == 'APPROVED'">
                  <el-popover
                    placement="top-start"
                    title="Approval details:"
                    width="300"
                    trigger="hover"
                  >
                    <div v-if="scope.row.priority_based">
                      <!-- In priority based approvals, only main approver details should be displayed -->
                      <span
                        v-if="getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_by"
                      >
                        Approved by: {{ getApprovedUser(scope.row).approved_by }}
                      </span>
                      <br />
                      <span
                        v-if="getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_at"
                      >
                        Approved on:
                        {{
                          convertToLocalDateTime(getApprovedUser(scope.row).approved_at)
                            | globalDateTimeFormat
                        }}
                      </span>
                      <br />
                      <span
                        v-if="
                          getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_reason
                        "
                      >
                        Approved Reason:
                        {{ getApprovedUser(scope.row).approved_reason }}
                      </span>
                    </div>
                    <div v-else>
                      <!-- In non-priority based(all users need to approve) approvals, all approvers details should be displayed -->
                      <ul>
                        <li
                          v-for="approver in getApprovedUser(scope.row)"
                          :key="approver._id"
                          class="list-style"
                        >
                          <div v-if="approver.approved_by && approver.approved_at">
                            <i class="el-icon-user-solid icon-style"></i>
                            Approved by:
                            <span class="approver-text">
                              {{ ' ' + approver.approved_by + ',' }}
                            </span>
                            <br />
                            <i class="el-icon-time icon-style"></i>
                            Approved at:
                            <span class="approver-text">
                              {{
                                (' ' + convertToLocalDateTime(approver.approved_at))
                                  | globalDateTimeFormat
                              }}
                            </span>
                            <br />
                            <span v-if="approver.approved_reason">
                              <i class="el-icon-edit-outline icon-style"></i>
                              Approved reason:
                              <span class="approver-text">
                                {{ ' ' + approver.approved_reason }}
                              </span>
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div slot="reference">
                      <i class="el-icon-success"></i>
                      <span class="d-inline-block !pl-1.5">
                        {{ scope.row.approval_status == 'APPROVED' ? 'Approved' : '' }}
                        <el-tooltip
                          trigger="hover"
                          effect="dark"
                          content="Revoke Approval"
                          placement="right"
                          v-if="
                            formbuilderDetails.allow_revoke_approval &&
                            checkRevokePermission('approved', scope.row) &&
                            scope.row.approval_status == 'APPROVED'
                          "
                        >
                          <el-link
                            type="warning"
                            @click="showRevokeApprovalConfirm(scope.row)"
                            :underline="false"
                          >
                            <i class="fa fa-level-up"></i>
                          </el-link>
                        </el-tooltip>
                      </span>
                    </div>
                  </el-popover>
                </div>
                <div class="error" v-else-if="scope.row.approval_status == 'REJECTED'">
                  <el-popover
                    placement="top-start"
                    title="Rejection details:"
                    width="300"
                    trigger="hover"
                  >
                    <div>
                      <span
                        v-if="getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_by"
                      >
                        Rejected by: {{ getRejectedUser(scope.row).rejected_by }}
                      </span>
                      <br />
                      <span
                        v-if="getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_at"
                      >
                        Rejected on:
                        {{
                          convertToLocalDateTime(getRejectedUser(scope.row).rejected_at)
                            | globalDateTimeFormat
                        }}
                      </span>
                      <br />
                      <span
                        v-if="
                          getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_reason
                        "
                        style="word-break: break-word"
                      >
                        Reason:
                        {{ getRejectedUser(scope.row).rejected_reason }}
                      </span>
                    </div>
                    <div slot="reference" class="expired-div">
                      <i class="el-icon-error"></i>
                      <span class="d-inline-block !pl-1.5">
                        {{ scope.row.approval_status == 'REJECTED' ? 'Rejected' : '' }}
                        <el-tooltip
                          trigger="hover"
                          effect="dark"
                          content="Revoke Approval"
                          placement="right"
                          v-if="
                            formbuilderDetails.allow_revoke_approval &&
                            checkRevokePermission('rejected', scope.row) &&
                            scope.row.approval_status == 'REJECTED'
                          "
                        >
                          <el-link
                            type="warning"
                            @click="showRevokeApprovalConfirm(scope.row)"
                            :underline="false"
                          >
                            <i class="fa fa-level-up"></i>
                          </el-link>
                        </el-tooltip>
                      </span>
                    </div>
                  </el-popover>
                </div>
                <div
                  :class="
                    getReviewerData(scope.row) && getReviewerData(scope.row).status == 'REJECTED'
                      ? 'error'
                      : 'success'
                  "
                  v-else-if="checkReviewer(scope.row)"
                >
                  <el-popover
                    placement="top-start"
                    :title="getReviewerData(scope.row).title"
                    width="300"
                    trigger="hover"
                  >
                    <div>
                      <span v-if="getReviewerData(scope.row).label1">
                        {{ getReviewerData(scope.row).label1 }}
                      </span>
                      <br />
                      <span v-if="getReviewerData(scope.row).date">
                        On:
                        {{ getReviewerData(scope.row).date | globalDateTimeFormat }}
                      </span>
                      <br />
                      <span v-if="getReviewerData(scope.row).reason" style="word-break: break-word">
                        Reason:
                        {{ getReviewerData(scope.row).reason }}
                      </span>
                    </div>
                    <div slot="reference">
                      <i
                        :class="
                          getReviewerData(scope.row).status == 'REJECTED'
                            ? 'el-icon-error'
                            : 'el-icon-success'
                        "
                      ></i>
                      <span class="d-inline-block" style="word-break: break-word">
                        {{
                          getReviewerData(scope.row).status +
                          ' by ' +
                          getReviewerData(scope.row).user_name
                        }}
                      </span>
                    </div>
                  </el-popover>
                </div>
                <div class="draft-color" v-else-if="scope.row.approval_status == 'DRAFT'">
                  <i class="el-icon-edit-outline"></i>
                  <span class="d-inline-block !pl-1.5">Draft</span>
                </div>
                <div
                  class="warning d-flex"
                  v-else-if="scope.row.approval_users && scope.row.approval_users.length"
                >
                  <formbuilderLogs
                    class="warning"
                    :currentFormbuilderData="scope.row"
                    :allEntitiesData="allEntitiesData"
                    :allCompanyUserTypesData="allCompanyUserTypesData"
                    v-on:reload-table="fetchAllEmployee"
                  ></formbuilderLogs>
                  <span class="d-inline-block !pl-1.5">
                    {{ scope.row.approval_status == 'HOLD' ? approvalHoldName : 'Pending' }}
                  </span>
                </div>
                <div class="warning" v-else>
                  <span class="d-inline-block !pl-1.5">Not approval data</span>
                </div>
              </template>
              <template v-else>
                <span class="warning" v-if="scope.row.approval_status == 'PENDING'">
                  <i class="el-icon-time"></i>
                  Pending
                </span>
                <span class="success" v-if="scope.row.approval_status == 'APPROVED'">
                  <i class="el-icon-success"></i>
                  Approved
                </span>
                <span class="error" v-if="scope.row.approval_status == 'REJECTED'">
                  <i class="el-icon-error"></i>
                  Rejected
                </span>
                <span class="draft-color" v-if="scope.row.approval_status == 'DRAFT'">
                  <i class="el-icon-edit"></i>
                  Draft
                </span>
                <el-tooltip content="Detailed Logs" effect="dark" placement="top">
                  <el-button type="text" @click="openAdvancedLogs(scope.row)">
                    <i class="fa fa-external-link"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>

          <el-table-column label="Sent Status" min-width="150" sortable="custom">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.sent_at" class="d-block yale-blue sm-80 line-height-1">
                  Sent On
                </span>
                <span class="black-coral sm-80" v-if="scope.row.sent_at">
                  {{ scope.row.sent_at | moment('MM-DD-YYYY HH:mm') }}
                </span>

                <span v-if="!scope.row.sent_at" class="d-block yale-blue sm-80 line-height-1">
                  Not Send
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Completion Status" width="250" fixed="right" sortable="custom">
            <template slot-scope="scope">
              <div
                class="warning"
                v-if="
                  scope.row.formbuilder_data_status == 'PENDING' ||
                  scope.row.formbuilder_data_status == 'SENT'
                "
              >
                <i class="el-icon-refresh"></i>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span class="d-inline-block !pl-1.5">
                  {{
                    scope.row.formbuilder_data_status == 'PENDING' ||
                    scope.row.formbuilder_data_status == 'SENT'
                      ? 'Pending'
                      : ''
                  }}
                  <el-tooltip
                    :content="getContent(scope.row)"
                    placement="top"
                    v-if="!isAnonymousForm()"
                  >
                    <el-button
                      @click="resendForm(scope.row)"
                      type="primary"
                      size="mini"
                      class="resend-form-style"
                    >
                      Resend
                    </el-button>
                  </el-tooltip>
                </span>
              </div>

              <div class="success" v-else-if="scope.row.formbuilder_data_status == 'COMPLETED'">
                <i class="el-icon-success"></i>
                <span class="d-inline-block !pl-1.5">
                  {{ scope.row.formbuilder_data_status == 'COMPLETED' ? 'Completed' : '' }}
                </span>
              </div>

              <div class="expired-div" v-else-if="scope.row.formbuilder_data_status == 'EXPIRED'">
                <i class="el-icon-error"></i>
                <span class="d-inline-block !pl-1.5">
                  {{ scope.row.formbuilder_data_status == 'EXPIRED' ? 'Expired' : '' }}
                </span>
              </div>

              <div v-else>Pending</div>
            </template>
          </el-table-column>
        </data-tables-server>
        <data-tables-server
          :data="data"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading"
          v-else-if="getIsMobile"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="expand-column-item" v-if="hasIntervals">
                <div class="expand-column-item-label">Submitted For</div>
                <div class="expand-column-item-content">
                  {{ scope.row.time_interval | moment(fequencyDateMap[intervalType]) }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Sent Status</div>
                <div class="expand-column-item-content">
                  {{ scope.row.sent_at | moment('MM-DD-YYYY HH:mm') }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Completion Status</div>
                <div class="expand-column-item-content">
                  <div class="warning">
                    <i
                      class="el-icon-refresh"
                      v-if="
                        scope.row.formbuilder_data_status == 'PENDING' ||
                        scope.row.formbuilder_data_status == 'SENT'
                      "
                    ></i>
                    <span class="d-inline-block !pl-1.5">
                      {{
                        scope.row.formbuilder_data_status == 'PENDING' ||
                        scope.row.formbuilder_data_status == 'SENT'
                          ? 'Pending'
                          : ''
                      }}
                    </span>
                  </div>

                  <div class="success">
                    <i
                      class="el-icon-success"
                      v-if="scope.row.formbuilder_data_status == 'COMPLETED'"
                    ></i>
                    <span class="d-inline-block !pl-1.5">
                      {{ scope.row.formbuilder_data_status == 'COMPLETED' ? 'Completed' : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="50" fixed="left">
            <template>
              <div>
                <i class="fa fa-user-circle !text-brand-500" width="30"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User" min-width="300" sortable="custom">
            <template slot-scope="scope">
              <div class="d-flex" v-if="!isAnonymousForm()">
                <div>{{ getUserEmail(scope.row) }}</div>
              </div>
              <div v-else>
                <div>{{ scope.row.ip_address }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="action" min-width="110px">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" :style="getIsMobile ? 'width:110px' : ''">
                  <a @click="viewFormbuilderData(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                  </a>
                  <a @click="editWorkUserData(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                      Edit
                    </el-dropdown-item>
                  </a>
                  <a @click="onDelete(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-delete" command="delete">
                      Delete
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
    <dialog-component
      :title="'Add ' + formbuilderDetails.name"
      :visible="openStartFormbuilderModal"
      @before-close="CloseStartFormbuilder"
      :containerWidth="getIsMobile ? '100%' : '30%'"
      class="add-contact-type-popup"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="formbuilder-Add">
        <el-scrollbar wrap-style="max-height: 600px;">
          <p v-if="formbuilderDetails.form_builders_owner == 'USER'">
            {{ 'To add ' + formbuilderDetails.name + ', select the company user email' }}
          </p>
          <p v-else-if="formbuilderDetails.form_builders_owner == 'ENTITY'">
            {{ 'To add ' + formbuilderDetails.name + ', select the application user email' }}
          </p>
          <p v-else>
            {{ 'To add ' + formbuilderDetails.name + ', select the receiver email' }}
          </p>
          <el-select
            v-model="formbuilderRecievers"
            placeholder="Select email"
            filterable
            style="width: 100%"
            v-if="formbuilderDetails.form_builders_owner == 'USER'"
            clearable
            multiple
            collapse-tags
          >
            <el-option
              v-for="contact in companyUsers"
              :key="contact._id"
              :label="contact.email"
              :value="contact._id"
            ></el-option>
          </el-select>
          <el-select
            v-model="formbuilderRecievers"
            placeholder="Select email"
            filterable
            style="width: 100%"
            v-else
            clearable
            multiple
            collapse-tags
          >
            <el-option
              v-for="contact in getContacts"
              :key="contact._id"
              :label="contact.email"
              :value="contact._id"
            ></el-option>
          </el-select>
        </el-scrollbar>
        <br />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="formbuilderRecievers.length === 0"
          :icon="!loading ? 'el-icon-s-promotion' : 'el-icon-loading'"
          @click="sendFormbuilder(formbuilderRecievers)"
          size="small"
          v-if="formbuilderRecievers.length !== 0"
        >
          Send Form
        </el-button>
        <el-button size="small" @click="openStartFormbuilderModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="reasonForRejectModal"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerHeight="getIsMobile ? '100%' : '42%'"
      title="Reason for reject"
      @before-close="reasonForRejectModaldialog"
    >
      <el-input
        type="textarea"
        :rows="6"
        placeholder="Reason for reject"
        v-model="reasonForReject"
        class="p-3"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectFormbuilder(reasonForRejectData)"
          type="primary"
          :disabled="!reasonForReject.length"
        >
          Submit
        </el-button>
        <el-button @click="reasonForRejectModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="reasonForReworkModal"
      :containerWidth="'55%'"
      :containerHeight="'75%'"
      title="Reason for rework"
      @before-close="reasonForReworkModaldialog"
    >
      <div
        v-loading="reworkDialogLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="Fetching fields, please wait..."
        class="p-3"
      >
        <div style="margin-bottom: 20px">
          <label style="font-weight: bold; display: block; margin-bottom: 5px">
            Select user type:
          </label>
          <el-select v-model="selectedReworkUserType" placeholder="Select type" style="width: 100%">
            <el-option
              v-for="(type, index) in reworkUserTypes"
              :key="index"
              :label="type.label"
              :value="type.value"
            />
          </el-select>
          <label style="font-weight: bold; display: block; margin-bottom: 5px; margin-top: 20px">
            Select user or approver:
          </label>
          <el-select
            v-if="selectedReworkUserType == 'SPECIFIC_USER'"
            v-model="selectedApproverEmail"
            placeholder="Select an approver"
            style="width: 100%"
          >
            <el-option
              v-for="(approver, index) in userAndApproversEmails"
              :key="index"
              :label="approver.label"
              :value="approver.value + (approver.levelIndex > -1 ? '#' + approver.levelIndex : '')"
            />
          </el-select>
          <el-select
            v-if="selectedReworkUserType == 'GROUP'"
            v-model="selectedApproverGroupIndex"
            placeholder="Select group"
            style="width: 100%"
          >
            <el-option
              v-for="(group, index) in approverGroups"
              :key="index"
              :label="
                'Approver Group - Level-' +
                (group.order + 1) +
                (group.filter_name ? ' - ' + group.filter_name : '')
              "
              :value="group.order"
            />
          </el-select>
        </div>

        <div>
          <label style="font-weight: bold; display: block; margin-bottom: 5px">Reason:</label>
          <CkEditorOffline v-model="reasonForRework" :config="editorConfig"></CkEditorOffline>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="onRework(reasonForReworkData)"
          type="primary"
          :disabled="
            !reasonForRework.length || (!selectedApproverEmail && selectedApproverGroupIndex == -1)
          "
        >
          Submit
        </el-button>
        <el-button @click="reasonForReworkModaldialog">Cancel</el-button>
      </span>
    </dialog-component>
    <el-drawer
      title="Privacy Link"
      :visible.sync="copyModal"
      :direction="'rtl'"
      :with-header="true"
      :size="getIsMobile ? '80%' : '20%'"
    >
      <IframeLink :routeKey="url_key" type="FormBuilderUserDate"></IframeLink>
    </el-drawer>
    <dialog-component
      title="Send Notification"
      :visible="sendNotificationDialog"
      :containerWidth="getIsMobile ? '100%' : '52%'"
      @before-close="sendNotificationDialog = false"
      :isShowFooter="false"
      v-loading="emailConfigLoading"
    >
      <EmailSendBox
        :paramsContent="paramsData"
        :customEmails="notificationEmails"
        v-on:closeNotificationDialog="closeSendNotificationDialog"
      ></EmailSendBox>
    </dialog-component>

    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showRevokeReasonDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for revoke approval"
      @before-close="closeRevokeDialog"
    >
      <div class="p-4">
        Are you sure to revoke the approval? Please mention your reason below:
        <el-input
          type="textarea"
          :rows="4"
          placeholder="Reason for revoke approval (Optional)"
          v-model="reasonForRevokeApproval"
          class="mt-1 mb-1"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="revokeApproval(reasonForRevokeApprovalData)" type="primary">
          Revoke
        </el-button>
        <el-button @click="closeRevokeDialog">Cancel</el-button>
      </span>
    </dialog-component>

    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showBulkRejectDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for rejection"
      @before-close="closeBulkRejectDialog"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="Reason for reject"
        v-model="reasonForBulkRejection"
        class="mt-1 mb-1"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectSelctedFormData()"
          type="primary"
          :disabled="!reasonForBulkRejection.length"
        >
          Submit & Reject All
        </el-button>
        <el-button @click="closeBulkRejectDialog">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      @before-close="reasonForApproveModaldialog"
      :visible="reasonForApproveModal"
      :title="approvalDialogTitle"
      :containerWidth="'40%'"
      :containerHeight="'42%'"
    >
      <div class="p-1 mb-2">
        <el-input
          v-if="formbuilderDetails && formbuilderDetails.show_approval_reason_dialog"
          type="textarea"
          :rows="6"
          placeholder="Reason for approve"
          v-model="reasonForApprove"
          class="p-3"
        ></el-input>
        <div class="ml-2" v-if="formbuilderDetails && formbuilderDetails.show_approval_rating">
          <span>Rating</span>
          <el-rate
            v-model="approval_rating"
            class="custom-large-stars"
            show-text
            :texts="['Needs Improvement', 'Developing', 'Competent', 'Proficient', 'Expert']"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="approveFormbuilder(reasonForApproveData)"
          type="primary"
          :disabled="
            !reasonForApprove.length &&
            formbuilderDetails &&
            formbuilderDetails.show_approval_reason_dialog
          "
        >
          Submit
        </el-button>
        <el-button @click="reasonForApproveModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <div v-if="showExportWidget">
      <templates-data-export-widget
        :key="exportWidgetKey"
        :formbuilderDetails="formbuilderDetails"
        :templatesFields="[]"
        :selectedFields="[]"
        :applicationUserFilledDataIds="[exportRowData._id]"
        :fromApprovalFormView="true"
      ></templates-data-export-widget>
    </div>
    <el-drawer
      title="Advanced Approval Logs"
      :visible.sync="showFormDataLogs"
      :direction="'rtl'"
      :with-header="true"
      :z-index="3000"
      :size="getIsMobile ? '80%' : '50%'"
      :before-close="closeFormDataLogs"
    >
      <formbuilderAdvancedLogs
        :key="clickedFormbuilderData?._id"
        :currentFormbuilderData="clickedFormbuilderData"
        :formbuilderDetails="formbuilderDetails"
      ></formbuilderAdvancedLogs>
    </el-drawer>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import config from '@/config/app';
  import FormbuilderHelper from '@/mixins/FormbuilderHelper.js';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper.js';
  import NavigationHelper from '@/mixins/navigationHelper';
  import CustomDashboardHelper from '../../mixins/CustomDashboardHelper';
  import EntityHelper from '@/mixins/EntitiesHelper';
  import { postAPICall } from '@/helpers/httpHelper';
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  import axios from 'axios';
  import JSZip from 'jszip';
  export default {
    name: 'FormbuilderUsersData',
    components: {
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
      formbuilderLogs: () => import('@/components/widgets/formbuilderLogsWidget'),
      formbuilderAdvancedLogs: () => import('@/components/widgets/formbuilderAdvancedLogsWidget'),
      automationFormbuilderLogs: () => import('@/components/widgets/formbuilderAutomationLogs'),
      IframeLink: () => import('../../views/iframeLink.vue'),
      EmailSendBox: () => import('../notifications/emailSendBox.vue'),
      TemplatesDataExportWidget: () => import('../widgets/templatesDataExportWidget'),
    },
    mixins: [
      FormbuilderHelper,
      TemplateBuilderHelper,
      NavigationHelper,
      CustomDashboardHelper,
      EntityHelper,
    ],
    data() {
      return {
        selectedApproverGroupIndex: null,
        approverGroups: [],
        reworkUserTypes: [
          { value: 'SPECIFIC_USER', label: 'Specific User' },
          { value: 'GROUP', label: 'Group' },
        ],
        selectedReworkUserType: 'SPECIFIC_USER',
        approval_rating: 0,
        approvalDialogTitle: 'Reason for approve',
        showFormDataLogs: false,
        clickedFormbuilderData: null,
        exportWidgetKey: 0,
        showExportWidget: false,
        exportRowData: null,
        reasonForApproveData: null,
        reasonForApprove: '',
        reasonForApproveModal: false,
        selectedApproverEmail: '',
        userAndApproversEmails: [],
        reworkDialogLoading: false,
        allMentionableFields: [],
        editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
        formbuilder_code: null,
        getCompanyUsers: [],
        getAllContacts: [],
        approvalFilter: [],
        searchQuery: '',
        sentStatusFilter: '',
        customDateRange: null,
        adjustedDateRange: null,
        loading: false,
        editDailogVisible: false,
        selectedOfferLetterTemplate: '',
        total: 0,
        currentPage: 1,
        pageSize: 0,
        data: [],
        addDialogVisible: false,
        previewDialogVisible: false,
        selectedOfferLetter: null,
        viewOfferLetterVisible: false,
        documentSelectDialogVisible: false,
        selectedConfigurableDocument: null,
        documentsLoading: false,
        selectedEmployee: null,
        title: '',
        firstTemplateFields: [],
        firstTemplateId: null,
        workflowIconPath: 'block-portfolio.svg',
        formbuilderDetails: {},
        workFlowPublicURL: '',
        selectedUserId: '',
        hasIntervals: false,
        intervalType: '',
        sendNotificationDialog: false,
        notificationEmails: [],
        paramsData: {},
        emailConfigLoading: false,
        fequencyDateMap: {
          DAILY: 'YYYY-DD-MM',
          WEEKLY: 'YYYY-DD-MM',
          MONTHLY: 'YYYY-DD-MM',
          YEARLY: 'YYYY-DD-MM',
          HOURLY: 'YYYY-DD-MM HH:mm',
        },
        openStartFormbuilderModal: false,
        formbuilderRecievers: [],
        isApprovalFormbuilder: false,
        approver: '',
        reasonForReject: '',
        reasonForRejectModal: false,
        reasonForRejectData: null,
        reasonForReworkData: null,
        reasonForRework: '',
        reasonForReworkModal: false,
        isApplicationUserSide: false,
        activeWorkspace: '',
        selectedRowsIds: [],
        allEntitiesData: [],
        allCompanyUserTypesData: [],
        companyUsers: [],
        copyModal: false,
        url_key: '',
        checkRoutekey: '',
        automationLogs: {},
        resendLoading: false,
        showRevokeReasonDialog: false,
        reasonForRevokeApproval: '',
        reasonForRevokeApprovalData: null,
        loadingText: 'Fetching data, please wait...',
        approvalHoldName: 'HOLD',
        showBulkRejectDialog: false,
        reasonForBulkRejection: '',
        templateData: [],
        entityData: [],
      };
    },
    computed: {
      ...mapGetters('formBuilders', [
        'getFormBuilderAddStatus',
        'getFormBuilder',
        'getFormBuilderRemindersSettings',
        'getFormBuilderUpdateStatus',
        'getFormBuilderPublicURLDetails',
      ]),
      ...mapGetters('formbuilderData', [
        'getResendApprovalMailstatus',
        'getFormbuilderUsersData',
        'getFormbuilderUniqueUsersData',
        'getFormbuilderCreateByContactData',
        'getFormbuilderCreateByContactStatus',
        'getFormbuilderCreateByContactErrors',
        'getFormbuilderDataDeleteStatus',
        'getFormbuilderDataDeleteError',
        'getFormbuilderDataUpdateStatus',
        'getFormbuilderDataUpdateError',
        'getFormbuilderDataBulkDeleteStatus',
        'getFormbuilderDataBulkDeleteErrors',
        'getSendFormBuilderToUsersStatus',
        'getSendFormBuilderToUsersErrors',
      ]),
      ...mapGetters('templatesData', ['getTemplateFieldsData']),
      ...mapGetters('companyEntities', ['getSingleCompanyEntity']),
      ...mapGetters('contacts', ['getCheckContactWithEmail']),
      ...mapGetters('navigationOpen', ['getIsMobile']),
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getUserType',
        'getCompanyUsersList',
      ]),
      ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveContactType', 'getUserTypeList']),
      ...mapGetters('menuManagementV2', ['getEntityMenu']),
      ...mapGetters('iFrame', ['getIframeUrlInfo']),
      ...mapGetters('company', ['getCompanyDetails', 'getFormBuilderSettings']),
      ...mapGetters('entitiesData', ['getCreateDocumentForEntityData']),
      buttonSize() {
        return this.formbuilderDetails?.customization?.add_button_size || 'mini';
      },
      buttonStyles() {
        return {
          backgroundColor: this.formbuilderDetails?.customization?.add_button_color || '#409EFF',
          borderColor: this.formbuilderDetails?.customization?.add_button_color || '#409EFF',
          color: '#fff',
        };
      },
      isAdvancedApproval() {
        return this.formbuilderDetails?.approval_configuration_type == 'ADVANCED' ? true : false;
      },
      isGenerateUniqueId() {
        return this.getCompanyDetails?.form_builder_settings?.is_generate_unique_id ? true : false;
      },
      isCompanyOwner() {
        return this.getFormBuilder.form_builders_owner == 'COMPANY';
      },
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 20, 50],
        };
      },
      getFormbuilerRoute() {
        return '/fb/' + this.formbuilder_code;
      },
      getFormbuilderTableDataRoute() {
        let queryString = this.currentMenu?.form_builder_type
          ? this.currentMenu.form_builder_type
          : 'FILLED_BY_ME';
        if (this.isApplicationUserSide || this.$route?.path?.includes('/ap/fbd/')) {
          const menuId = this.$route.query.menuId || this.$route.params.menuId;
          const route =
            '/ap/fbdv/' +
            this.formbuilder_code +
            '/data-list?' +
            `${queryString}` +
            (menuId ? `&menuId=${menuId}` : '');
          return route;
        }
        if (this.getIframeUrlInfo != null) {
          const route = `/if/${this.getIframeUrlInfo._id}/fbd/${this.formbuilder_code}/data-list`;
          return route;
        }
        const route = '/fbd/' + this.formbuilder_code + '/data-list';
        return route;
      },

      getWorkflowTableBatchesRoute() {
        return '/fbd/' + this.formbuilder_code + '/batches';
      },
      getWorkflowTableAllUsersRoute() {
        return '/fbd/' + this.formbuilder_code + '/all-users';
      },
      logoUploadUrl() {
        return config.S3_BUCKET_URL;
      },
      getUserEmail() {
        return (formbuilderData) => {
          if (formbuilderData.contact) {
            return formbuilderData.contact && formbuilderData.contact.email
              ? formbuilderData.contact.email
              : '';
          }
          return '';
        };
      },
      getUserName() {
        return (formbuilderData) => {
          if (formbuilderData.contact) {
            return formbuilderData.contact &&
              formbuilderData.contact.first_name &&
              formbuilderData.contact.first_name
              ? formbuilderData.contact.first_name + ' ' + formbuilderData.contact.last_name
              : '';
          }
          return '';
        };
      },
      getUserId() {
        return (workflowData) => {
          if (this.formbuilderDetails.form_builders_owner == 'COMPANY') {
            return workflowData.workflow_user_id && workflowData.workflow_user_id._id
              ? workflowData.workflow_user_id._id
              : '';
          } else if (this.formbuilderDetails.form_builders_owner == 'ENTITY') {
            return workflowData.entity_data && workflowData.entity_data.email
              ? workflowData.entity_data.entity_data_id
              : '';
          } else {
            return workflowData.user_id && workflowData.user_id._i ? workflowData.user_id._id : '';
          }
        };
      },
      getFormbuilderSteps() {
        if (this.formbuilderDetails && this.formbuilderDetails.steps) {
          return this.formbuilderDetails.steps.map((step) => {
            if (step.type == 'ENTITY') {
              return {
                type: 'ENTITY',
                step_id: step._id,
                entity_id: step && step.entity && step.entity._id ? step.entity._id : step.entity,
              };
            } else {
              return {
                type: 'TEMPLATE',
                step_id: step._id,
                template_id:
                  step && step.template && step.template._id ? step.template._id : step.template,
              };
            }
          });
        }
        return [];
      },
      getContacts() {
        return this.getAllContacts && this.getAllContacts.data ? this.getAllContacts.data : [];
      },
      currentMenu() {
        if (
          this.isApplicationUserSide &&
          (this.$route.params.menuId || this.$route.query.menuId) &&
          this.getEntityMenu?.menu_list
        ) {
          let menu;
          let id = this.$route.params.menuId || this.$route.query.menuId;
          this.getEntityMenu.menu_list.forEach((e) => {
            if (e._id == id) {
              menu = e;
            } else if (e.children) {
              (e.children || []).forEach((el) => {
                if (el._id == id) {
                  menu = el;
                } else if (el.children) {
                  (el.children || []).forEach((ele) => {
                    if (ele._id == id) {
                      menu = ele;
                    }
                  });
                }
              });
            }
          });
          return menu;
        }
        return null;
      },
      displayBackButton() {
        if (this.getIframeUrlInfo) {
          let modifiedKey = this.checkRoutekey;
          if (this.checkRoutekey.startsWith('if#')) {
            const parts = this.checkRoutekey.split('#');
            if (parts.length > 2) {
              modifiedKey = parts.slice(2).join('#');
            }
          }
          if (modifiedKey === this.getIframeUrlInfo.url_key) {
            return false;
          }
        }
        return true;
      },
      userEmails() {
        return this.userData.map((user) => this.getUserEmail(user)).filter((email) => email !== '');
      },
      isUserFieldPresent() {
        return (
          this.data &&
          this.data.some(
            (record) => record.contact && record.contact.email === this.getAuthenticatedUser.email
          ) &&
          this.formbuilderDetails &&
          this.formbuilderDetails.settings &&
          this.formbuilderDetails.settings.frequency === false
        );
      },
    },
    async created() {
      this.setRouteConfiguration();
      if (this.getFormbuilderUsersData.data && this.getFormbuilderUsersData.data.length) {
        this.data = this.getFormbuilderUsersData.data;
      } else {
        this.data = [];
      }
    },
    async mounted() {
      let limit = (this.pageSizes && this.pageSizes[0]) || 10;
      this.pageSize = limit;
      [this.allCompanyUserTypesData, this.allEntitiesData] = await Promise.all([
        this.fetchCompanyUsersTypes(true),
        this.fetchAllEntities(),
        this.getNecessaryInfo(),
      ]);
      await this.$store.commit('formBuilders/setFormBuilderPrevRouter', null, {
        root: true,
      });
      this.checkRoutekey = this.generateOutputFromUrl(this.$route.fullPath, [
        'key',
        'page',
        'pageSize',
      ]);
      await this.loadTemplatesData();
      if (
        (this.$route.query?.addnew == 'true' || this.$route.query?.addnew == true) &&
        !this.isUserFieldPresent
      ) {
        this.openStartFormbuilder();
      }
      this.configCKeditor();
      this.getApproverGroups();
    },
    methods: {
      getApproverGroups() {
        let allApproverGroups = this.formbuilderDetails.approval_users.filter(
          (e) => e.user_type == 'APPLICATION' && e.individual_entity_resource == 'FILTER'
        );
        this.approverGroups = allApproverGroups;
      },
      checkContactEmail(data) {
        let formData = this.templateData.find((e) => e._id == data._id);
        return formData?.contact?.email &&
          formData.contact.email !== this.getAuthenticatedUser.email
          ? true
          : false;
      },
      getContent() {
        return (formbuilderData) => {
          let name = this.getUserName(formbuilderData);
          let email = this.getUserEmail(formbuilderData);
          if (name && email) {
            return 'Resend the form to ' + name + ' (' + email + ')';
          }
          return 'Resend the form to the user';
        };
      },
      isAnonymousForm() {
        return this.formbuilderDetails?.form_builders_owner === 'ANONYMOUS';
      },
      openAdvancedLogs(rowData) {
        this.clickedFormbuilderData = { ...rowData };
        this.$nextTick(() => {
          this.showFormDataLogs = true;
        });
      },
      closeFormDataLogs() {
        this.showFormDataLogs = false;
        this.clickedFormbuilderData = null;
      },
      exportFormbuilderAsExcel(formData) {
        this.showExportWidget = false;
        this.exportRowData = null;
        this.exportRowData = { ...formData };
        this.$nextTick(() => {
          this.exportWidgetKey++;
          this.showExportWidget = true;
        });
      },
      exportFormbuilderDataAsPdf(data) {
        let entityStep = data.formbuilder_steps_data.find(
          (s) => s.type == 'ENTITY' && s.entity_id && s.entity_data_id
        );
        let entityDetails = this.formbuilderDetails.steps.find(
          (s) => s.type == 'ENTITY' && s.entity._id == entityStep.entity_id
        );
        if (entityDetails?.entity?.default_printing_document && entityStep?.entity_data_id) {
          this.printEntityDataOnDocument(entityDetails.entity, entityStep.entity_data_id);
        } else {
          return this.$message.warning('Please generate a document template in the entity!');
        }
      },
      async printEntityDataOnDocument(entityInfo, entityDataId) {
        this.loading = true;
        this.loadingText = 'Downloading pdf, please wait...';

        await this.$store.dispatch('entitiesData/createDocumentFromEntityData', {
          entity_data_id: entityDataId,
          entity_id: entityInfo._id,
          document_id: entityInfo.default_printing_document || '',
          custom_message: entityInfo?.pdf_printing_info?.custom_message || '',
        });

        if (
          this.getCreateDocumentForEntityData &&
          this.getCreateDocumentForEntityData.generatedDocuments
        ) {
          this.loading = false;
          this.loadingText = '';

          this.downloadEntityDataPdf(
            this.getCreateDocumentForEntityData.generatedDocuments,
            this.getCreateDocumentForEntityData?.doc_printing_names.length &&
              this.getCreateDocumentForEntityData.doc_printing_names[0]
              ? this.getCreateDocumentForEntityData.doc_printing_names[0].trim()
              : entityInfo && entityInfo.name
                ? entityInfo.name
                : 'Data '
          );
        } else {
          this.loadingText = '';
          this.loading = false;

          this.$message({
            message: 'Error while generating document',
            type: 'error',
          });
        }
      },
      async downloadDocuments(rowData) {
        let filteredDocumentFields = this.allMentionableFields.filter(
          (e) => e.input_type == 'FILE'
        );
        let formbuilderData = this.templateData.find((f) => f._id == rowData._id);
        let documentsData = [];
        if (filteredDocumentFields?.length) {
          filteredDocumentFields.forEach((f) => {
            let keyParts = f.template_key.split('#');
            if (keyParts.length == 3) {
              let entityId = keyParts[0];
              let fieldKey = keyParts[1] + '#' + keyParts[2];
              if (formbuilderData?.entityData?.[entityId]?.[fieldKey]) {
                let document = formbuilderData.entityData[entityId][fieldKey];
                if (document?.files?.length) {
                  documentsData = [...document.files, ...documentsData];
                }
              }
            } else if (keyParts.length == 2) {
              let templateId = keyParts[0];
              let fieldKey = keyParts[1];
              if (formbuilderData?.templateData?.[templateId]?.[fieldKey]) {
                let document = formbuilderData.templateData[templateId][fieldKey];
                if (document?.files?.length) {
                  documentsData = [...document.files, ...documentsData];
                }
              }
            }
          });
        }
        if (documentsData.length == 1) {
          await this.onDownloadFile(documentsData[0]);
        } else if (documentsData.length > 1) {
          //download all docs in a zip file
          await this.downloadMultipleDocsAsZip(documentsData);
        } else {
          this.$message.warning('No documents found in this form data');
        }
      },
      async onDownloadFile(data) {
        this.loading = true;
        this.loadingText = 'Downloading File....';
        let fileName = data.name;
        fileName = await fileName.replace(/\//g, '-');
        fileName = await fileName.replace(/ /g, '_');
        fileName = await fileName.replace(/[()]/g, '');
        if (data && !data.path) {
          data.path = `template-data-documents/${fileName}`;
        }
        await this.$store.dispatch('templatesData/downloadTemplateDocument', {
          path: data.path,
        });
        await fetch(this.getDownloadUrl, {
          method: 'GET',
          responseType: 'blob',
        })
          .then((res) => res.blob())
          .then((response) => {
            var fileURL = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.loading = false;
          });
        if (this.getDownloadUrl) {
          // get Download Url
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getDownloadError,
          });
        }
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async downloadMultipleDocsAsZip(docsData) {
        this.loading = true;
        this.loadingText = 'Downloading Zip, please wait...';
        let docUrls = [];

        for (const data of docsData) {
          let fileName = data.name;
          fileName = fileName.replace(/\//g, '-').replace(/ /g, '_').replace(/[()]/g, '');

          if (data && !data.path) {
            data.path = `template-data-documents/${fileName}`;
          }

          await this.$store.dispatch('templatesData/downloadTemplateDocument', {
            path: data.path,
          });

          if (this.getDownloadUrl) {
            docUrls.push({ url: this.getDownloadUrl, name: fileName });
          }
        }

        if (docUrls.length === 0) {
          console.log('No documents found to download.');
          return;
        }

        let zipName = docUrls[0].name || 'documents';
        await this.downloadMultipleEntityDataPdfs(docUrls, zipName);
        this.loading = false;
        this.loadingText = '';
      },
      downloadMultipleEntityDataPdfs(pdfUrls, zipName) {
        const zip = new JSZip();
        const promises = pdfUrls.map((url) =>
          axios
            .get(url.url, { responseType: 'blob' })
            .then((response) => zip.file(url.name, response.data))
        );

        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: 'blob' }).then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${zipName}.zip`;
              a.click();
              window.URL.revokeObjectURL(url);
            });
          })
          .catch((error) => {
            console.error('Error while downloading files:', error);
          });
      },
      checkRevokePermission(status, data) {
        let currentuserIndex = this.getCurrentApprover(data);
        let isAllowed = false;
        if (this.isApplicationUserSide) {
          if (currentuserIndex > -1) {
            // Yes approver
            if (status == 'approved') {
              isAllowed =
                this.formbuilderDetails?.allow_revoke_for_approved ||
                this.formbuilderDetails?.allow_revoke_for_both;
            } else if (status == 'rejected') {
              isAllowed =
                this.formbuilderDetails?.allow_revoke_for_rejected ||
                this.formbuilderDetails?.allow_revoke_for_both;
            }
          } else {
            //Not approver means filler
            if (status == 'approved') {
              isAllowed =
                this.formbuilderDetails?.allow_revoke_for_approved_for_filler ||
                this.formbuilderDetails?.allow_revoke_for_both_for_filler;
            } else if (status == 'rejected') {
              isAllowed =
                this.formbuilderDetails?.allow_revoke_for_rejected_for_filler ||
                this.formbuilderDetails?.allow_revoke_for_both_for_filler;
            }
          }
        } else {
          if (status == 'approved') {
            isAllowed =
              this.formbuilderDetails?.allow_revoke_for_approved ||
              this.formbuilderDetails?.allow_revoke_for_both;
          } else if (status == 'rejected') {
            isAllowed =
              this.formbuilderDetails?.allow_revoke_for_rejected ||
              this.formbuilderDetails?.allow_revoke_for_both;
          }
        }
        return isAllowed;
      },
      reasonForApproveModaldialog() {
        this.reasonForApproveModal = false;
      },
      async getFormMentionableFields() {
        try {
          this.reworkDialogLoading = true;
          const formbuilder_id = this.formbuilderDetails._id;
          const stepsDataUrl = `/formBuilders/all-fields/${formbuilder_id}`;
          const response = await postAPICall('GET', stepsDataUrl);
          response.steps_data.forEach((step) => {
            if (step.type == 'ENTITY' && Array.isArray(step.templates)) {
              step.templates.forEach((temp) => {
                const mentionableFields = temp.fields.map((e) => {
                  return {
                    ...e,
                    mention_key: `${step.entity}#${temp.template_id}#${e.key}`,
                    label: `${step.entity_name}-${temp.template_name}-${e.label}`,
                    template_key: `${step.entity}#${temp.template_id}#${e.key}`,
                  };
                });
                this.allMentionableFields.push(...mentionableFields);
              });
            }

            if (step.type == 'TEMPLATE') {
              const mentionableFields = step.fields.map((e) => {
                return {
                  ...e,
                  mention_key: `${step.template}#${e.key}`,
                  label: `${step.template_name}-${e.label}`,
                  template_key: `${step.template}#${e.key}`,
                };
              });
              this.allMentionableFields.push(...mentionableFields);
            }
          });
          if (this.allMentionableFields?.length) {
            this.allMentionableFields = this.allMentionableFields.map((item) => {
              return {
                label: item.label,
                template_key: item.template_key,
                id: item.mention_key,
                input_type: item.inputType,
              };
            });
          }
          this.configCKeditor();
          this.reasonForRework = this.mapMailTemplatevariables(this.reasonForRework);
        } catch (error) {
          console.log('Error in getFormMentionableFields:', error);
        } finally {
          this.reworkDialogLoading = false;
        }
      },
      configCKeditor() {
        this.editorConfig.mentions = [
          {
            feed: this.dataFeed,
            itemTemplate:
              '<li data-id="{id}">' + '<strong class="label">{label}</strong>' + '</li>',
            outputTemplate: '<span>&nbsp;</span><span>[[{label}]]</span><span>&nbsp;</span>',
            minChars: 0,
            convertTo: function (item) {
              return {
                template_key: item.label,
              };
            },
          },
          {
            feed: '/tags?name={encodedQuery}',
            marker: '#',
          },
        ];
        this.editorConfig.id = 'rework_reason_template';
      },
      dataFeed(opts, callback) {
        var matchProperty = 'label',
          data = this.allMentionableFields.filter(function (item) {
            return item[matchProperty].toLowerCase().indexOf(opts.query.toLowerCase()) !== -1;
          });
        data = data.sort(function (a, b) {
          return a[matchProperty].localeCompare(b[matchProperty], undefined, {
            sensitivity: 'accent',
          });
        });
        callback(data);
      },
      mapMailTemplatevariables(body, revert) {
        const childRegex = /\[\[(.*?)\]\]/g;
        const childVariables = [];
        let match;
        while ((match = childRegex.exec(body)) !== null) {
          childVariables.push(match[1]);
        }
        // Replace labels with their corresponding template_keys (need to change for other entities labels)
        body = body.replace(/\[\[(.*?)\]\]/g, (match, label) => {
          const template = this.allMentionableFields.find(
            (obj) => (!revert && obj.label === label) || (revert && obj.id == label)
          );
          let value = '';
          if (revert) {
            value = template?.label;
          } else {
            value = template?.template_key;
          }
          if (template?.input_type == 'PAY_BUTTON') {
            return template ? `[[${value}#pay]]` : match;
          }
          return template ? `[[${value}]]` : match;
        });
        return body;
      },
      getReworkLabel() {
        return this.formbuilderDetails?.customization?.rework_button_name
          ? this.formbuilderDetails.customization.rework_button_name
          : 'Rework';
      },
      reasonForReworkModaldialog() {
        this.reasonForReworkModal = false;
        this.selectedReworkUserType = '';
        this.selectedApproverGroupIndex = -1;
      },
      showReworkConfirm(formbuilderData) {
        if (
          formbuilderData.approval_status == 'HOLD' &&
          formbuilderData?.current_dependent_formbuilderdata?._id &&
          formbuilderData?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = formbuilderData?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        this.reasonForReworkData = null;
        this.reasonForRework = '';
        this.reasonForReworkModal = true;
        this.reasonForReworkData = { ...formbuilderData };
        this.getApprovers(formbuilderData);
      },
      async onRework(formbuilderData) {
        this.reasonForReworkModal = false;
        this.resendLoading = true;
        this.reasonForRework = this.mapMailTemplatevariables(this.reasonForRework, false);
        let approverGroupData = {};
        let isApproverGroup = false;
        if (this.selectedReworkUserType == 'GROUP' && this.selectedApproverGroupIndex) {
          isApproverGroup = true;
          approverGroupData = formbuilderData.approval_users[this.selectedApproverGroupIndex];
          approverGroupData.mappedGroupApprovers = this.userAndApproversEmails.map((e) => ({
            ...e,
          }));
        }
        let params = {
          formbuilder_data_id: formbuilderData._id,
          formbuilders_details_id: this.formbuilderDetails._id,
          company_id: formbuilderData?.company,
          rework_reason: this.reasonForRework,
          is_approver:
            this.selectedApproverEmail.includes('approver#') || isApproverGroup ? true : false,
          approver_data:
            this.selectedApproverEmail.includes('approver#') || isApproverGroup
              ? this.userAndApproversEmails.find(
                  (e) =>
                    e.value ==
                      this.selectedApproverEmail.split('#')[0] +
                        '#' +
                        this.selectedApproverEmail.split('#')[1] &&
                    e.levelIndex == Number(this.selectedApproverEmail.split('#')[2])
                )
              : this.userAndApproversEmails.find((e) => e.value == this.selectedApproverEmail),
          isApproverGroup: isApproverGroup,
          approverGroupData: approverGroupData,
        };
        try {
          let response = await postAPICall('POST', '/formbuilder-data/rework-form', params);
          if (response.success && response.data) {
            this.$notify.success({
              title: 'Success',
              message: 'Form sent to user email!',
            });
          }
          this.fetchAllEmployee();
          this.resendLoading = false;
        } catch (err) {
          console.log('error while sending the form :', err);
        }
      },
      extractEmailsFromTemplates(templateData) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.notificationEmails = [];
        templateData.forEach((item) => {
          if (item.templateData && typeof item.templateData === 'object') {
            Object.keys(item.templateData).forEach((templateId) => {
              const fields = item.templateData[templateId];

              Object.keys(fields).forEach((fieldKey) => {
                const fieldValue = fields[fieldKey];

                if (typeof fieldValue === 'string' && emailRegex.test(fieldValue)) {
                  this.notificationEmails.push(fieldValue);
                }
              });
            });
          }
        });
      },
      extractEmailsFromEntityData(entityData) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const collectedEntityEmails = [];
        entityData.forEach((entity) => {
          if (entity && typeof entity.email === 'string' && emailRegex.test(entity.email)) {
            collectedEntityEmails.push(entity.email);
          }
        });
        this.notificationEmails = [
          ...new Set([...this.notificationEmails, ...collectedEntityEmails]),
        ];
      },
      async loadTemplatesData() {
        let params = {
          formbuilder_details_id: this.formbuilderDetails._id,
        };
        try {
          const response = await postAPICall(
            'GET',
            'formbuilder-template-data/template-data',
            params
          );
          let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (Array.isArray(response.data)) {
            this.templateData = response.data;
            this.entityData = [];
            response.data.forEach((record) => {
              if (record.entityData) {
                for (let entityId in record.entityData) {
                  let entityRecord = record.entityData[entityId];
                  Object.values(entityRecord).forEach((value) => {
                    if (typeof value == 'string' && emailRegex.test(value)) {
                      this.notificationEmails.push(value);
                    }
                  });
                }
              }
              if (record.templateData) {
                for (let templateId in record.templateData) {
                  let templateRecord = record.templateData[templateId];
                  Object.values(templateRecord).forEach((value) => {
                    if (typeof value == 'string' && emailRegex.test(value)) {
                      this.notificationEmails.push(value);
                    }
                  });
                }
              }
            });
          } else {
            console.warn('No valid data received from API or data is not an array.');
          }
        } catch (error) {
          console.error('Error loading template data:', error);
        }
      },
      handleSelectionChange(checkedRows) {
        this.selectedRowsIds = checkedRows;
        if (this.templateData && this.selectedRowsIds?.length) {
          this.checkEmailMatches(this.selectedRowsIds);
        }
      },
      async handleNotificationClick() {
        this.checkEmailMatches();
        if (this.notificationEmails.length > 0) {
          this.openNotificationsDialog({ emails: this.notificationEmails });
        } else {
          this.$message.error('No valid email addresses found.');
        }
      },
      checkEmailMatches() {
        let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let selectedRowIds = this.selectedRowsIds.map((row) => row._id);
        let filteredData = this.templateData.filter((item) => selectedRowIds.includes(item._id));
        this.notificationEmails = [];
        filteredData.forEach((record) => {
          if (record.entityData) {
            for (let entityId in record.entityData) {
              let entityRecord = record.entityData[entityId];
              Object.values(entityRecord).forEach((value) => {
                if (typeof value == 'string' && emailRegex.test(value)) {
                  this.notificationEmails.push(value);
                }
              });
            }
          }
          if (record.templateData) {
            for (let templateId in record.templateData) {
              let templateRecord = record.templateData[templateId];
              Object.values(templateRecord).forEach((value) => {
                if (typeof value == 'string' && emailRegex.test(value)) {
                  this.notificationEmails.push(value);
                }
              });
            }
          }
        });
      },
      async approveAllChecked() {
        this.$confirm('Are you sure to approve the selected form responses?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.approveSelectedFormData();
        });
      },
      //Bulk Approve form responses
      async approveSelectedFormData() {
        this.loading = true;
        this.loadingText = 'Approving the form responses, please wait...';
        let params = [];
        this.selectedRowsIds.forEach((item, i) => {
          if (
            item &&
            item._id &&
            (item.approval_status == 'PENDING' || item.approval_status == 'HOLD')
          ) {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              let approvalData = this.getApprovalParams(item, currentuserIndex);
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Form responses approved successfully',
            });
            this.fetchAllEmployee();
          }
        }
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      showBulkRejectConfirm() {
        this.showBulkRejectDialog = true;
        this.reasonForBulkRejection = '';
      },

      closeBulkRejectDialog() {
        this.showBulkRejectDialog = false;
        this.reasonForBulkRejection = '';
      },
      //Bulk reject form responses
      async rejectSelctedFormData() {
        this.loading = true;
        this.loadingText = 'Rejecting the form responses, please wait...';
        let params = [];
        this.selectedRowsIds.forEach((item, i) => {
          if (
            item &&
            item._id &&
            (item.approval_status == 'PENDING' || item.approval_status == 'HOLD')
          ) {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              let approvalData = this.getRejectParams(
                item,
                currentuserIndex,
                this.reasonForBulkRejection
              );
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Form responses rejected successfully',
            });
            this.fetchAllEmployee();
          }
        }
        this.closeBulkRejectDialog();
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      async holdAllChecked() {
        this.$confirm('Are you sure to hold the selected form responses?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.holdSelctedFormData();
        });
      },
      async holdSelctedFormData() {
        this.loading = true;
        this.loadingText = 'Holding the form responses, please wait...';
        let params = [];
        let approvalData = {
          approval_status: 'HOLD',
        };
        this.selectedRowsIds.forEach((item, i) => {
          if (item && item._id && item.approval_status == 'PENDING') {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: `Form responses ${this.approvalHoldName} successfully`,
            });
            this.fetchAllEmployee();
          }
        }
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      showRevokeApprovalConfirm(formbuilderData) {
        this.reasonForRevokeApprovalData = null;
        this.reasonForRevokeApproval = '';
        this.reasonForRevokeApprovalData = { ...formbuilderData };
        if (this.formbuilderDetails?.show_revoke_reason_dialog) {
          this.showRevokeReasonDialog = true;
        } else {
          this.$confirm('Are you sure to revoke the approval?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.revokeApproval(this.reasonForRevokeApprovalData);
          });
        }
      },
      closeRevokeDialog() {
        this.showRevokeReasonDialog = false;
      },
      async revokeApproval(data) {
        try {
          this.showRevokeReasonDialog = false;
          this.loading = true;
          this.loadingText = 'Revoking approval, please wait...';
          if (
            data?.allow_revoke_approval &&
            ['APPROVED', 'REJECTED'].includes(data.approval_status)
          ) {
            const response = await postAPICall('POST', '/formbuilder-data/revoke-approval', {
              formbuilder_details_id: data.formbuilders_details_id,
              formbuilder_data_id: data._id,
              revoke_reason: this.reasonForRevokeApproval,
              revoked_by:
                this.getAuthenticatedUser?.first_name +
                ' ' +
                this.getAuthenticatedUser?.last_name +
                '#' +
                this.getAuthenticatedUser?.email,
            });
            if (response) {
              this.$notify.success({
                title: 'Success',
                message: 'Approval revoked successfully',
              });
              this.fetchAllEmployee();
              this.loading = false;
            }
            this.loading = false;
            this.loadingText = '';
            this.reasonForRevokeApprovalData = null;
            this.reasonForRevokeApproval = '';
          }
        } catch (err) {
          console.log('error while revoking approval', err);
        }
      },
      async openNotificationsDialog(paramsData) {
        this.paramsData = paramsData;
        this.notificationEmails = paramsData.emails;
        if (this.notificationEmails.length > 0) {
          this.sendNotificationDialog = true;
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Please select user emails.',
            type: 'error',
          });
        }

        if (this.notificationEmails.length > 0) {
          this.sendNotificationDialog = true;
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Please select user emails.',
            type: 'error',
          });
        }
      },
      async closeSendNotificationDialog(params) {
        this.emailConfigLoading = true;
        params.company_id = this.getFormBuilder.company;
        let endPoint = '/entities-data/users/send-notification';
        let response = await postAPICall('POST', endPoint, params);
        if (response) {
          this.emailConfigLoading = false;
          this.$notify({
            title: 'Success',
            message: 'Sending mail(s) initiated',
            type: 'success',
          });
        } else {
          this.emailConfigLoading = false;
          this.$notify({
            title: 'Error',
            message: 'Error while sending mails',
            type: 'error',
          });
        }
        this.sendNotificationDialog = false;
      },
      getAllEmails() {
        if (Array.isArray(this.getFormBuilder)) {
          return this.getFormBuilder.map((formBuilder) => formBuilder.contact.email);
        }
        return [];
      },
      async onSentStatusChange() {
        if (this.sentStatusFilter !== 'custom_date_range') {
          this.customDateRange = null;
          await this.fetchAllEmployee();
        }
      },

      onDateRangeChange() {
        if (this.customDateRange && this.sentStatusFilter === 'custom_date_range') {
          const startDate = this.customDateRange[0];
          let endDate = new Date(this.customDateRange[1]);
          endDate.setDate(endDate.getDate() + 1);
          this.adjustedDateRange = [startDate, endDate];
          this.fetchAllEmployee();
        }
      },
      async resendForm(formbuilderData) {
        this.resendLoading = true;
        let response;
        let params = {
          formbuilder_data_id: formbuilderData._id,
          formbuilders_details_id: formbuilderData.formbuilders_details_id,
          contact: formbuilderData.contact,
          company_id: formbuilderData.company,
        };
        try {
          response = await postAPICall('POST', '/formbuilder-data/resend-form', params);
          if (response.success && response.data) {
            this.$notify.success({
              title: 'Success',
              message: 'Form sent to user email successfully',
            });
          }
          this.resendLoading = false;
        } catch (err) {
          console.log('error while sending the form :', err);
        }
        this.resendLoading = false;
      },
      async onHold(row) {
        this.$confirm('Are you sure to hold the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.holdFormbuilder(row);
        });
      },
      async holdFormbuilder(formbuilderData) {
        this.loading = true;
        let currentuserIndex = this.getCurrentApprover(formbuilderData);
        if (currentuserIndex > -1) {
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', {
            approval_status: 'HOLD',
            id: formbuilderData._id,
          });
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: `Form state updated to ${this.approvalHoldName} successfully!`,
              type: 'success',
            });
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message:
                this.getFormbuilderDataUpdateError.message ||
                'Error while Form state updated to hold',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loading = false;
      },
      checkReceiverPermissions(access, data) {
        // If form is approved, whether need to give permissions to view, edit, delete submission for receiver(application user or company user)
        if (
          (this.$route?.name == 'applicationFormBuilderUserData' ||
            this.$route?.query?.routeType == 'FB') &&
          data.approval_status !== 'PENDING'
        ) {
          if (
            this.formbuilderDetails?.approval_receiver_permissions &&
            data.approval_status == 'APPROVED'
          ) {
            let permissions = this.formbuilderDetails.approval_receiver_permissions;
            if (access == 'view' && permissions.view == true) {
              return true;
            } else if (access == 'edit' && permissions.edit == true) {
              return true;
            } else if (access == 'delete' && permissions.delete == true) {
              return true;
            } else {
              return false;
            }
          } else if (
            this.formbuilderDetails?.rejection_receiver_permissions &&
            data.approval_status == 'REJECTED'
          ) {
            let permissions = this.formbuilderDetails.rejection_receiver_permissions;
            if (access == 'view' && permissions.view == true) {
              return true;
            } else if (access == 'edit' && permissions.edit == true) {
              return true;
            } else if (access == 'delete' && permissions.delete == true) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return true;
        }
      },
      reasonForRejectModaldialog() {
        this.reasonForRejectModal = false;
      },
      //send form builder to selected contacts
      async sendFormbuilder(users) {
        let params = {
          selectedUsers: users,
          formbuilder_details_id: this.formbuilderDetails._id,
        };
        this.loading = true;
        await this.$store.dispatch('formbuilderData/sendFormBuilderToUsers', params);
        if (this.getSendFormBuilderToUsersStatus) {
          this.$notify.success({
            title: 'Success',
            message: 'Form builder data is being created, and sending mail has been initiated.',
          });
          this.loading = false;
          this.fetchAllEmployee();
        } else {
          let message = 'Error while sending mail';
          if (this.getSendFormBuilderToUsersErrors) {
            message = this.getSendFormBuilderToUsersErrors;
          }
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
        this.openStartFormbuilderModal = false;
      },
      async deleteChecked() {
        this.$confirm('Are you sure to delete the form response data?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.deleteSelectedFormData();
        });
      },
      //Bulk delete form response data
      async deleteSelectedFormData() {
        let selectedIds = [];
        this.selectedRowsIds.forEach((item) => {
          if (item && item._id) {
            selectedIds.push(item._id);
          }
        });
        let params = {
          selectedIds: selectedIds,
          formbuilder_details_id: this.getFormBuilder._id,
        };
        this.loading = true;
        await this.$store.dispatch('formbuilderData/formBuilderDataBulkDelete', params);
        if (this.getFormbuilderDataBulkDeleteStatus) {
          this.loading = false;
          this.$notify.success({
            title: 'Success',
            message: 'Form data deleted successfully',
          });
          this.fetchAllEmployee();
        } else {
          let message = 'Error while deleting data';
          if (this.getFormbuilderDataBulkDeleteErrors) {
            message = this.getFormbuilderDataBulkDeleteErrors;
          }
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
      },
      setRouteConfiguration() {
        if (this.$route?.name == 'applicationFormBuilderUserData') {
          if (this.getActiveContactType?.contact_type?._id) {
            this.activeWorkspace = this.getActiveContactType.contact_type._id;
          }

          if (
            this.$route?.params?.menuId ||
            this.$route?.query?.menuId ||
            this.$route?.fullPath?.includes('FILLED_BY_ME')
          ) {
            this.isApplicationUserSide = true;
          }
        }
      },
      convertToLocalDateTime(dateTime) {
        const date = new Date(dateTime);
        return date.toLocaleString();
      },
      getApprovedUser(formbuilderData) {
        // In priority based approvals, only main approver details should be displayed
        if (formbuilderData?.approval_users && formbuilderData?.priority_based) {
          return formbuilderData?.approval_users.find(
            (e) =>
              (!formbuilderData.priority_based && e.approved_status) ||
              (formbuilderData.priority_based && e.approved_status && e.final_approver)
          );
        } else {
          // In non-priority based(all users need to approve) approvals, all approvers details should be displayed, so returning all the approvers
          return formbuilderData?.approval_users;
        }
      },
      getRejectedUser(formbuilderData) {
        if (formbuilderData?.approval_users) {
          return formbuilderData?.approval_users.find(
            (e) =>
              (!formbuilderData.priority_based && e.rejected_status) ||
              (formbuilderData.priority_based && e.rejected_status && e.final_approver)
          );
        }
        return null;
      },
      checkIsApproverUser(formbuilderData) {
        let isAdvanced =
          this.formbuilderDetails.approval_configuration_type == 'ADVANCED' ? true : false;
        if (
          (formbuilderData?.advanced_approval_users?.length || formbuilderData?.approval_users) &&
          formbuilderData?.approval_status != 'APPROVED' &&
          formbuilderData?.approval_status != 'REJECTED'
        ) {
          let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
          if (isAdvanced) {
            let advApprovers = formbuilderData?.advanced_approval_users.find(
              (e) => e.current_level_index == currentuserIndex
            );
            let advancedApprover = advApprovers?.approval_users?.find(
              (e) => e.contact_id == this.getAuthenticatedUser._id
            );
            return (
              advancedApprover?.approval_status == 'PENDING' &&
              formbuilderData.formbuilder_data_status == 'COMPLETED'
            );
          }
          if (
            currentuserIndex > -1 &&
            !formbuilderData.approval_users[currentuserIndex].approved_status &&
            !formbuilderData.approval_users[currentuserIndex].rejected_status
          ) {
            return formbuilderData.formbuilder_data_status == 'COMPLETED';
          }
          return false;
        }
        return false;
      },
      checkIsLoginUserAsApproverUser() {
        let currentuserIndex = this.getCurrentApprover(this.getFormBuilder);
        return currentuserIndex > -1 ? true : false;
      },
      async onReject(row) {
        this.$confirm('Are you sure to reject the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.rejectFormbuilder(row);
        });
      },
      showRejectConfirm(formbuilderData) {
        if (
          formbuilderData.approval_status == 'HOLD' &&
          formbuilderData?.current_dependent_formbuilderdata?._id &&
          formbuilderData?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = formbuilderData?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        this.reasonForRejectData = null;
        this.reasonForReject = '';
        this.reasonForRejectModal = true;
        this.reasonForRejectData = { ...formbuilderData };
      },
      async rejectFormbuilder(formbuilderData) {
        this.loading = true;
        this.reasonForRejectModal = false;
        this.loadingText = 'Rejecting the form, please wait...';
        let isAdvanced =
          this.formbuilderDetails.approval_configuration_type == 'ADVANCED' ? true : false;
        let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        if (currentuserIndex > -1) {
          let params = this.getRejectParams(
            formbuilderData,
            currentuserIndex,
            this.reasonForReject,
            isAdvanced
          );
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', params);
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: 'Rejected successfully!',
              type: 'success',
            });
            this.reasonForRejectData = null;
            this.reasonForReject = '';
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message: this.getFormbuilderDataUpdateError.message || 'Error while approving',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loadingText = '';
        this.loading = false;
      },
      async onApprove(row) {
        if (
          row.approval_status == 'HOLD' &&
          row?.current_dependent_formbuilderdata?._id &&
          row?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = row?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        if (
          this.formbuilderDetails?.show_approval_reason_dialog &&
          this.formbuilderDetails.show_approval_rating
        ) {
          this.reasonForApproveData = null;
          this.reasonForApprove = '';
          this.reasonForApproveModal = true;
          this.reasonForApproveData = { ...row };
          this.approvalDialogTitle = 'Approval Rating & Reason';
        } else if (this.formbuilderDetails?.show_approval_reason_dialog) {
          this.approvalDialogTitle = 'Approval Reason';
          this.reasonForApprove = '';
          this.reasonForApproveModal = true;
          this.reasonForApproveData = { ...row };
        } else if (this.formbuilderDetails?.show_approval_rating) {
          this.approval_rating = null;
          this.approvalDialogTitle = 'Approval Rating';
          this.reasonForApproveModal = true;
        } else {
          this.$confirm('Are you sure about approving the response?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.approveFormbuilder(row);
          });
        }
      },
      async approveFormbuilder(formbuilderData) {
        this.reasonForApproveModal = false;
        this.loading = true;
        this.loadingText = 'Approving the form, please wait...';
        let isAdvanced =
          this.formbuilderDetails.approval_configuration_type == 'ADVANCED' ? true : false;
        let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        if (currentuserIndex > -1) {
          let params = this.getApprovalParams(
            formbuilderData,
            currentuserIndex,
            this.reasonForApprove,
            isAdvanced
          );
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', params);
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: 'Approved successfully!',
              type: 'success',
            });
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message: this.getFormbuilderDataUpdateError.message || 'Error while approving',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loadingText = '';
        this.loading = false;
      },
      async startFormbuilder() {
        this.openStartFormbuilderModal = false;
        // Redirecting to preview form to fill the form by owner/sender if there is only one receiver
        let url = config.APP_URL;
        url += `/owner/fb/${this.formbuilderDetails.code}/${this.formbuilderDetails.steps[0].slug}/${this.formbuilderDetails._id}?user_id=${this.getAuthenticatedUser._id}`;
        window.open(url, '_blank');
        let params = this.prepareParams();
        await this.$store.dispatch('formbuilderData/createFormbuilderDataByContact', params);
        if (this.getFormbuilderCreateByContactStatus) {
          this.$message({
            message: 'Form data created successfully!',
            type: 'success',
          });
        } else {
          this.$notify.error({
            title: 'Error',
            message:
              this.getFormbuilderCreateByContactErrors &&
              this.getFormbuilderCreateByContactErrors.critical_error
                ? this.getFormbuilderCreateByContactErrors.critical_error
                : 'Something went wrong',
          });
        }
      },
      prepareParams() {
        return {
          formbuilders_details_id: this.formbuilderDetails._id,
          contact: this.formbuilderReciever,
          formbuilder_steps_data: this.getFormbuilderSteps,
        };
      },
      async openStartFormbuilder() {
        if (
          this.isApplicationUserSide &&
          this.formbuilderDetails?.form_builders_owner == 'ENTITY' &&
          this.formbuilderDetails?.entity_id == this.activeWorkspace
        ) {
          const url = `/ap/fbd/${this.formbuilderDetails.code}/${this.formbuilderDetails.steps[0].slug}/${this.formbuilderDetails._id}?user_id=${this.getAuthenticatedUser._id}`;
          this.openURL(url, this.getFormBuilderSettings?.navigation?.add || 'NEW_TAB');
          return;
        }
        if (
          !this.isApplicationUserSide &&
          this.formbuilderDetails?.form_builders_owner == 'USER' &&
          this.formbuilderDetails?.user_type.includes(this.getActiveWorkspace.user_type)
        ) {
          this.loading = true;
          await this.$store.dispatch('contacts/fetchContactByEmail', {
            email: this.getAuthenticatedUser.email,
            company_id: this.formbuilderDetails.company,
          });
          if (this.getCheckContactWithEmail?._id) {
            const url = `/public/fbd/${this.formbuilderDetails.code}/${this.formbuilderDetails.steps[0].slug}/${this.formbuilderDetails._id}?user_id=${this.getCheckContactWithEmail._id}`;
            this.openURL(url, this.getFormBuilderSettings?.navigation?.add || 'NEW_TAB');
            this.loading = false;
            return;
          } else {
            this.loading = false;
          }
        } else {
          this.loading = true;
          let params = {
            get_all: true,
            type: 'CONTACT',
            include_all_details: false,
          };
          if (
            this.formbuilderDetails?.form_builders_owner == 'ENTITY' &&
            this.formbuilderDetails?.entity_id
          ) {
            params = {
              ...params,
              ...{ contact_type: this.formbuilderDetails.entity_id },
            };
          } else if (
            this.formbuilderDetails?.form_builders_owner === 'USER' &&
            this.formbuilderDetails?.user_type
          ) {
            this.getCompanyUsers = await postAPICall('GET', '/user/companyUsers', params);
            if (this.getCompanyUsers?.data) {
              this.companyUsers = this.getCompanyUsers.data.filter((user) => {
                if (user?.rolesList) {
                  let existed = user.rolesList.find(
                    (role) =>
                      role &&
                      role.userType &&
                      this.formbuilderDetails.user_type.includes(role.userType._id || role.userType)
                  );
                  return existed ? true : false;
                }
              });
            }
          }
          this.getAllContacts = await postAPICall('GET', '/contacts', params);
          if (this.getAllContacts?.data || this.getCompanyUsers) {
            this.loading = false;
            this.openStartFormbuilderModal = true;
          }
        }
      },
      openURL(url, action = 'NEW_WINDOW') {
        switch (action) {
          case 'SELF':
            this.$router.push({ path: url });
            break;
          case 'NEW_TAB':
            window.open(config.APP_URL + url, '_blank');
            break;
          case 'NEW_WINDOW':
            window.open(config.APP_URL + url, 'MsgWindow', 'width=800,height=800');
            break;
          default:
            this.$router.push({ path: url });
            break;
        }
      },
      printScope(r) {
        console.log(r);
      },
      async getNecessaryInfo() {
        this.loading = true;
        this.selectedUserId = this.$route.params.user_id;

        this.formbuilder_code = this.$route.params.formbuilder_code;

        await this.$store.dispatch('formBuilders/fetchFormBuilderByCode', {
          code: this.formbuilder_code,
          include_template_details: true,
          include_entity_details: true,
          include_documents_details: true,
        });

        this.formbuilderDetails = this.getFormBuilder;

        this.hasIntervals = this.getFormBuilder?.settings?.interval_settings?.status;

        this.intervalType = this.getFormBuilder?.settings?.interval_settings?.type || null;
        this.isApprovalFormbuilder = this.formbuilderDetails?.is_approval_form || false;
        let templateIds = this.getFormBuilder.steps
          .filter((step) => step.type == 'TEMPLATE')
          .map((e) => e.template._id);

        let entityIds = this.getFormBuilder.steps
          .filter((step) => step.type == 'ENTITY')
          .map((e) => e.entity._id);

        this.workflowIconPath =
          this.getFormBuilder.icon_type == 'DEFAULT'
            ? this.getFormBuilder.icon || 'block-portfolio.svg'
            : 'block-portfolio.svg';

        this.firstTemplateId = templateIds ? templateIds[0] : null;
        if (templateIds?.length) {
          await this.$store.dispatch('templatesData/fetchTemplateFieldsData', {
            template_ids: [this.firstTemplateId],
          });
        }
        if (entityIds?.length) {
          await this.$store.dispatch('companyEntities/fetchSingleCompanyEntity', entityIds[0]);
        }
        await Promise.all([
          this.generateFormbuilderPublicURL(),
          this.fetchAllEmployee(),
          this.getFormMentionableFields(),
        ]);

        this.approvalHoldName = this.getCompanyDetails?.formbuilder_approval_hold_name
          ? this.getCompanyDetails.formbuilder_approval_hold_name
          : 'HOLD';
      },
      async getApprovers(data) {
        this.userAndApproversEmails = [];
        let userEmailEntry = {
          label: `USER - ${data?.contact?.email}`,
          value: `user#${data?.contact?.email}`,
          is_approver: false,
        };
        const url = '/formbuilder-data/fetch-approvers';
        let params = {
          formbuilder_data: data,
          approvers: this.formbuilderDetails.approval_users,
          include_user_contact: typeof data?.contact == 'string' ? data.contact : false,
        };
        let response = await postAPICall('POST', url, params);
        this.userAndApproversEmails = [userEmailEntry, ...(response.approver_emails || [])];
        if (!this.formbuilderDetails?.enforce_order) {
          this.userAndApproversEmails = this.userAndApproversEmails.filter(
            (usr) => usr.email !== this.getAuthenticatedUser.email
          );
        }
        let isAdvanced =
          this.formbuilderDetails?.approval_configuration_type == 'ADVANCED' ? true : false;
        if (this.formbuilderDetails?.enforce_order) {
          let currentLevelIndex = this.getCurrentApprover(data, isAdvanced);
          let filteredApprovers = this.userAndApproversEmails.filter((approver) => {
            if (approver?.value?.includes('user#')) {
              return true;
            }
            return approver.levelIndex < currentLevelIndex;
          });
          this.userAndApproversEmails = filteredApprovers;
          this.userAndApproversEmails = this.userAndApproversEmails.map((e) =>
            e.value.includes('user#')
              ? e
              : {
                  ...e,
                  label:
                    e.label.split(' - ')[0] +
                    ' - ' +
                    ' Level-' +
                    (e.levelIndex + 1) +
                    ' - ' +
                    e.label.split(' - ')[1],
                }
          );
        }
      },

      onEdit(row) {
        this.selectedOfferLetterTemplate = row;
        this.editDailogVisible = true;
      },
      async onView(row) {
        this.selectedOfferLetterTemplate = row;
        this.previewDialogVisible = true;
      },
      async onDelete(row) {
        this.$confirm('Are you sure to delete the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.deleteTemplate(row);
        });
      },
      async deleteTemplate(row) {
        //deleteFormbuilderData
        await this.$store.dispatch('formbuilderData/deleteFormbuilderData', row._id);
        if (this.getFormbuilderDataDeleteStatus) {
          this.$message({
            message: 'Response deleted successfully!',
            type: 'success',
          });
          this.fetchAllEmployee();
        } else {
          this.$notify.error({
            title: 'Error',
            message: "Something went wrong. Can't delete.",
          });
        }
      },

      async updateUserQuery(value) {
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, user_id: value },
        });

        await this.getNecessaryInfo();
      },
      async sendForApproval(data) {
        let formBuilderDataId = data?._id;
        let formBuilderId = data?.formbuilders_details_id;
        let allowed_users = data.approval_users || [];
        this.loading = true;
        let params = {
          formbuilder_id: formBuilderId,
          formbuilder_data_id: formBuilderDataId,
          allowed_users,
        };
        await this.$store.dispatch('formbuilderData/resendApprovalMail', { params });
        if (this.getResendApprovalMailstatus) {
          this.$message.success('Sent for approval successfully');
          this.$emit('reload-table');
          data.approval_status = 'PENDING';
          data.formbuilder_data_status = 'COMPLETED';
        } else {
          this.$message.error('Error while sending mail');
        }
        this.loading = false;
      },
      async fetchAllEmployee() {
        this.loading = true;
        this.data = [];
        let params = {
          page: this.currentPage,
          limit: this.pageSize,
          formbuilder_details_id: this.getFormBuilder._id,
          include_template_details: false,
          include_user_details: true,
          user_id: this.$route.query.user_id,
          approval_status: this.approvalFilter,
          searchQuery: this.searchQuery,
        };

        if (this.sentStatusFilter) {
          if (this.sentStatusFilter === 'custom_date_range' && this.adjustedDateRange) {
            params['sent_at'] = this.adjustedDateRange;
          } else {
            const dateFilter = this.getDatePickerHelper1(this.sentStatusFilter, new Date());
            params['sent_at'] = dateFilter.value;
          }
        }
        if (
          this.isApplicationUserSide &&
          (this.currentMenu?.form_builder_type == 'FILLED_BY_ME' ||
            this.$route?.fullPath?.includes('FILLED_BY_ME'))
        ) {
          params['user_id'] = this.getAuthenticatedUser._id;
        }
        if (this.currentMenu?.formbuilder_approval_filter?.length) {
          params['approval_status'] = this.currentMenu.formbuilder_approval_filter;
        }
        if (this.currentMenu?.form_builder_type == 'FILLED_BY_BUSINESS_CONTACTS') {
          params['is_business_contacts'] = true;
          params['account_data_id'] = this.getAuthenticatedUser?.account_data_id || '';
          params['contact_type'] = this.getAuthenticatedUser?.contact_type || '';
        }
        await this.$store.dispatch('formbuilderData/fetchUsersFormbuilderData', params);
        this.loading = false;
        this.currentPage = parseInt(this.getFormbuilderUsersData.page) || 1;
        this.total = parseInt(this.getFormbuilderUsersData.total) || 0;

        if (this.getFormbuilderUsersData.data && this.getFormbuilderUsersData.data.length) {
          this.data = this.getFormbuilderUsersData.data;
          await this.getEnforceOrderLogs(this.data);
          this.extractEmails(this.data);
          this.extractCompanies(this.data);
        } else {
          this.data = [];
        }
      },
      extractEmails(usersData) {
        let extractedEmails = usersData
          .map((user) => (user.contact ? user.contact.email : null))
          .filter((email) => email);
        return [...new Set([...extractedEmails])];
      },
      extractCompanies(usersData) {
        this.companyIds = usersData
          .map((user) => (user.company ? user.company : null)) // Extract company ID
          .filter((company) => company); // Filter out null values
      },
      async getEnforceOrderLogs(data) {
        let automation_batch_data_ids = data
          .filter((d) => d.next_user_data && d.automation_batch_data_id)
          .map((d) => d.automation_batch_data_id);

        const response = await postAPICall('POST', '/formbuilder-data/enforce-order-logs', {
          automation_batch_data_ids,
        });
        (response.data || []).forEach((e) => {
          let data = {};
          let currentUser = (e.data || []).find((f) => f.status == 'SENT');
          let isCompleted = (e.data || []).every((f) => f.status == 'COMPLETED');
          data['currentUser'] = currentUser;
          data['logs'] = e.data || [];
          data['status'] = isCompleted ? 'COMPLETED' : 'PENDING';
          this.$set(this.automationLogs, e._id, data);
        });
      },

      backToWorkFlows() {
        let UrlPathAdd = '';
        if (this.getIframeUrlInfo != null) {
          UrlPathAdd = `/if/${this.getIframeUrlInfo._id}/formBuilders`;
        } else {
          UrlPathAdd = '/formBuilders';
        }
        this.$router.push({ path: UrlPathAdd, query: this.$route.query });
      },
      CloseStartFormbuilder() {
        this.openStartFormbuilderModal = false;
      },
      parseFirstTemplateData(data) {
        let modifiedData = data.map((e) => {
          let dataObject = {
            _id: e._id,
            name: e.name,
            code: e.code,
            formbuilder_data_status: e.formbuilder_data_status,
            workflow_data_sender_status: e.workflow_data_sender_status,
          };

          let firstTemplateData = e.template_data_ids.find(
            (x) => x.template_id._id == this.firstTemplateId
          );

          if (firstTemplateData) {
            let firstTemplateValues =
              firstTemplateData.template_data_id && firstTemplateData.template_data_id.template_data
                ? firstTemplateData.template_data_id.template_data
                : {};
            dataObject.template_data = firstTemplateValues;
          } else {
            dataObject.template_data = {};
          }

          return dataObject;
        });
        return modifiedData;
      },
      async fetchAllConfigurableDocuments() {
        this.documentsLoading = true;
        await this.$store.dispatch('configurableDocuments/fetchConfigurableDocuments', {
          get_all: true,
          type: 'FORM',
        });
        this.documentsLoading = false;
      },
      copyURL(url) {
        navigator.clipboard.writeText(url);
        this.$message({
          message: 'Link copied successfully!',
          type: 'success',
        });
      },

      async generateFormbuilderPublicURL() {
        try {
          this.loading = true;
          await this.$store.dispatch('formBuilders/fetchWorkFlowPublicURL', {
            formbuilder_details_id: this.getFormBuilder._id,
          });
          if (this.getFormBuilder?.customization?.show_link_to_be_copy) {
            this.workFlowPublicURL = this.getFormBuilderPublicURLDetails.public_url;
          }
          this.false = true;
        } catch (err) {
          console.log('generateFormbuilderPublicURL', err);
        }
      },
      async loadData(data) {
        if (this.data && this.data.length) {
          this.pageSize = data.pageSize;
          this.page = data.page;
          await this.fetchAllEmployee();
        }
      },

      async selectDocuemnt(doc) {
        this.selectedConfigurableDocument = doc;
      },
      async viewFormbuilderData(row) {
        if (this.$route.name == 'applicationFormBuilderUserData') {
          await this.$store.commit('formBuilders/setFormBuilderPrevRouter', window.location.href, {
            root: true,
          });
          this.$router.push({
            name: 'ApplicationUserFormbuilderView',
            params: {
              formbuilder_code: this.formbuilder_code,
              formbuilder_data_id: row._id,
            },
            query: {
              fromDataList: 'true',
            },
          });
        } else {
          let urlName = '';
          if (this.getIframeUrlInfo != null) {
            urlName = 'FormbuilderViewSSO_External';
          } else {
            urlName = 'FormbuilderView';
          }
          this.$router.push({
            name: urlName,
            params: {
              formbuilder_code: this.formbuilder_code,
              formbuilder_data_id: row._id,
            },
          });
        }
      },
      async editWorkUserData(row) {
        if (this.$route.name == 'applicationFormBuilderUserData') {
          await this.$store.commit('formBuilders/setFormBuilderPrevRouter', window.location.href, {
            root: true,
          });
          this.$router.push({
            name: 'ApplicationUserFormbuilderEdit',
            params: {
              formbuilder_code: this.formbuilder_code,
              formbuilder_data_id: row._id,
            },
            query: {
              origin: 'cwdjkrni',
              fromDataList: 'true',
            },
          });
        } else {
          let urlName = '';
          if (this.getIframeUrlInfo != null) {
            urlName = 'FormbuilderEditSSO_External';
          } else {
            urlName = 'FormbuilderEdit';
          }
          this.$router.push({
            name: urlName,
            params: {
              formbuilder_code: this.formbuilder_code,
              formbuilder_data_id: row._id,
            },
          });
        }
      },
      getFlowName() {
        return this.getFormBuilder?.name;
      },

      getFieldData(templateData, field) {
        if (templateData[field.key]) {
          if (field.input_type == 'DATE') {
            return this.$moment.utc(templateData[field.key]).format('MM-DD-YYYY');
          }
          return templateData[field.key];
        }
        return '-';
      },
      openViewConfigPage() {
        ((this.url_key = this.$route.fullPath), (this.copyModal = true));
      },
    },
    watch: {
      '$route.params.workflow_code': async function () {
        await this.getNecessaryInfo();
      },
      async '$route.query.key'() {
        this.getNecessaryInfo();
      },
      async '$route.params.formbuilder_code'() {
        this.getNecessaryInfo();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .draft-color {
    color: #6c757d;
  }
  .formbuilder-Add {
    margin: 20px;
  }

  .el-range-editor.el-input__inner {
    width: 220px;
  }

  .filter-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    width: auto;
  }

  .filter-item {
    flex-shrink: 0;
  }

  .filter-item .el-select,
  .filter-item .el-input,
  .filter-item .el-date-picker {
    min-width: 120px;
  }

  .add-buttons {
    border: 1.5px solid var(--primary-color-brand);
    box-sizing: border-box;
    border-radius: 2px;
    padding: 0.45em 0.65em;
    color: var(--primary-contrast-color);

    &:hover {
      background-color: var(--brand-500);
      color: var(--primary-contrast-color);
      border-color: var(--brand-500);
    }
  }

  #workflow-users-list {
    width: 100%;
    margin: 0 auto;

    .el-dialog__body {
      padding: 20px 20px;

      .el-card {
        .el-card__body {
          padding: 10px;
        }

        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .doc {
    min-width: 30px;

    &.selected {
      background: green;
    }
  }

  .green {
    color: green;
  }

  .font-17 {
    font-size: 17px;
    cursor: pointer;
  }

  .documents {
    min-height: 200px;
    max-height: 400px;
    overflow: scroll;
  }

  .el-table .cell {
    word-break: break-word;
  }

  .el-table .td {
    word-wrap: break-word;
  }

  .approver-text {
    color: #3366cc;
  }

  .list-style {
    margin-top: 10px;
  }

  .expired-div {
    color: #dc3545;
  }

  .dull-text {
    color: #888;
    opacity: 0.8;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .log-expired {
    color: #dc3545;
  }
</style>
<style scoped>
  .el-alert__title.is-bold {
    font-weight: 500 !important;
  }

  .el-alert {
    display: block;
  }

  .el-alert__content {
    display: block;
  }

  .el-alert .el-alert__description {
    font-size: 12px;
    margin: 5px 0 0;
    width: 100%;
    background: #fff;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    align-items: center;
  }

  .el-checkbox {
    margin-bottom: 0px !important;
  }
  ::v-deep(.custom-large-stars .el-rate__icon) {
    font-size: 26px !important;
  }
</style>
